import React from 'react';

function IconNotifications() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="20"
      fill="none"
      viewBox="0 0 16 20"
    >
      <path
        fillRule="evenodd"
        d="M3.305 6.444a4.694 4.694 0 019.39 0v1.684c0 .715.236 1.352.502 1.896.133.274.282.538.42.783l.042.074c.126.222.242.428.348.633.155.302.243.646.243 1.011 0 1.077-.765 1.975-1.797 2.118-1.405.195-3.124.385-4.453.385-1.329 0-3.048-.19-4.453-.385-1.032-.143-1.797-1.04-1.797-2.118 0-.365.088-.709.243-1.011.105-.205.222-.41.348-.633l.042-.074c.138-.245.287-.51.42-.783.266-.544.502-1.18.502-1.896V6.444zM8 .25a6.194 6.194 0 00-6.195 6.194v1.684c0 .385-.127.78-.35 1.238a13.22 13.22 0 01-.378.702l-.042.075c-.124.218-.256.451-.376.686a3.707 3.707 0 00-.409 1.696c0 1.79 1.283 3.353 3.091 3.604 1.417.196 3.222.4 4.659.4 1.437 0 3.242-.204 4.659-.4 1.808-.25 3.091-1.813 3.091-3.604 0-.61-.147-1.187-.409-1.696-.12-.235-.252-.468-.376-.686l-.042-.075a13.202 13.202 0 01-.378-.702c-.224-.457-.35-.853-.35-1.238V6.444A6.194 6.194 0 008 .25zm1.32 17.18a.75.75 0 011.249.831 3.081 3.081 0 01-5.138 0 .75.75 0 011.249-.83 1.581 1.581 0 002.64 0z"
        clipRule="evenodd"
      />
    </svg>
  );
}

export default IconNotifications;
